/* sp-marke.js – Farbwahl (Farbkarten-Kacheln) und Logo-Schalter im Hero der Markenseite. Bilder anderer Farben laden erst beim Klick. */
(function () {
  function widths(img) {
    var ws = img.getAttribute('data-spm-ws');
    return ws ? ws.split(',').map(Number) : [400, 600, 900];
  }
  function sizes(url, ws) {
    return ws.map(function (w) { return url + '?width=' + w + ' ' + w + 'w'; }).join(', ');
  }
  function init(root) {
    if (root.dataset.spmInit) return;
    root.dataset.spmInit = '1';
    var chips = root.querySelectorAll('[data-spm-color]');
    var imgs = root.querySelectorAll('img[data-spm-imgs]');
    var cname = root.querySelectorAll('[data-spm-cname]');
    var cta = root.querySelector('[data-spm-cta]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var c = chip.getAttribute('data-spm-color');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === chip ? 'true' : 'false'); });
        imgs.forEach(function (img) {
          var map;
          try { map = JSON.parse(img.getAttribute('data-spm-imgs')); } catch (e) { return; }
          if (!map[c]) return;
          img.classList.add('is-loading');
          img.onload = function () { img.classList.remove('is-loading'); };
          var ws = widths(img);
          img.srcset = sizes(map[c], ws);
          img.src = map[c] + '?width=' + ws[1];
          var alt = img.getAttribute('data-spm-alt');
          if (alt) img.alt = alt.replace('[color]', chip.getAttribute('data-spm-name'));
        });
        cname.forEach(function (n) { n.textContent = chip.getAttribute('data-spm-name'); });
        if (cta) {
          var u = cta.getAttribute('data-spm-href');
          cta.href = u + (u.indexOf('?') > -1 ? '&' : '?') + 'farbe=' + encodeURIComponent(chip.getAttribute('data-spm-name'));
        }
      });
    });
    var tgl = root.querySelector('[data-spm-logo]');
    if (tgl) {
      tgl.addEventListener('click', function () {
        var on = tgl.getAttribute('aria-pressed') !== 'true';
        tgl.setAttribute('aria-pressed', on ? 'true' : 'false');
        root.setAttribute('data-logo', on ? 'on' : 'off');
      });
    }
  }
  function all() { document.querySelectorAll('[data-spm-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
